/** Tab / document.title: "Print — {presentation}", never layout/title doubled. */
export function formatPrintWindowTitle(presentation: string): string {
  const label = presentation.trim();
  return label ? `Print — ${label}` : 'Print';
}
